import { Row } from "antd";
import { IntervalSelector } from "../../IntervalSelector";
import { TooltipInfo } from "./TooltipInfo";

type HeaderProps = {
  granularity: number;
  setGranularity: React.Dispatch<React.SetStateAction<number>>;
};

export const Header = ({ granularity, setGranularity }: HeaderProps) => {
  return (
    <Row className="justify-space-between align-center">
      <Row className="align-center">
        <p className="text my-0 mr-2">Chat Conversations</p>
        <TooltipInfo />
      </Row>
      <IntervalSelector value={granularity} onSelect={setGranularity} />
    </Row>
  );
};
